module.exports = __webpack_public_path__ + "img/page.ffcaa549.png";